module.exports = __webpack_public_path__ + "static/media/pill-savaysa.1b92c1a7.svg";